import React, { useContext } from 'react';
import { FormattedMessage } from '@edx/frontend-platform/i18n';
import { Hyperlink, MailtoLink } from '@edx/paragon';
import { getConfig } from '@edx/frontend-platform';
import ExamStateContext from '../../context';

const ErrorProctoredExamInstructions = () => {
  const state = useContext(ExamStateContext);
  const {
    link_urls: linkUrls,
    platform_name: platformName,
    proctoring_escalation_email: proctoringEscalationEmail,
    contact_us,
  } = state.proctoringSettings || {};

  const { SUPPORT_URL } = getConfig();

  const renderBody = () => {
    if (proctoringEscalationEmail) {
      return (
        <FormattedMessage
          id="exam.ErrorProctoredExamInstructions.text1"
          defaultMessage={'A system error has occurred with your proctored exam. '
          + 'Please reach out to your course team at {supportLink} for assistance, '
          + 'and return to the exam once you receive further instructions.'}
          values={{ supportLink: <MailtoLink to={proctoringEscalationEmail}>{proctoringEscalationEmail}</MailtoLink> }}
        />
      );
    }

    return (
      <>
        <p>
          <FormattedMessage
            id="exam.ErrorProctoredExamInstructions.address"
            defaultMessage={'Dear listener!'}
          />
        </p>
        <p>
          <FormattedMessage
            id="exam.ErrorProctoredExamInstructions.errorText"
            defaultMessage={'An error occurred while taking the exam. Please proceed to the exam either through the Examus window or through the “Incomplete Exams” tab!'}
          />
        </p>
        <p>
          <FormattedMessage
            id="exam.ErrorProctoredExamInstructions.additionalAttempt"
            defaultMessage={'To grant an additional attempt, please contact {supportLink}.'}
            values={{
              supportLink: <Hyperlink href={SUPPORT_URL} target="_blank">
                <FormattedMessage id="exam.ErrorProctoredExamInstructions.supportLinkLabel" defaultMessage="link" />
              </Hyperlink>,
            }}
          />
        </p>
      </>
    );
  };

  return (
    <div>
      <div className="h3">
        <FormattedMessage
          id="exam.ErrorProctoredExamInstructions.title"
          defaultMessage="Error with proctored exam"
        />
      </div>
      <p className="mb-0">
        {renderBody()}
      </p>
    </div>
  );
};

export default ErrorProctoredExamInstructions;
